
import { defineComponent, onMounted } from "vue";
export default defineComponent({
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    closable: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Lorem ipsum",
    },
  },
  emits: ["close"],
  setup(props, context) {
    onMounted(() => console.info("Composition API Dialog mounted"));

    const onClose = () => {
      context.emit("close");
    };

    const onShow = () => {
      //context.emit("onShow");
    };

    return {
      onClose,
      onShow,
    };
  },
});
